import { FC } from 'react';
import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { mapSharedPropertiesToFields } from 'common/getters';
import { SitecoreFieldTypes } from 'common/types/sitecore';
import { LinkBlockComponent } from 'composables/shared/LinkBlock/LinkBlockComponent';
import { LinkBlockItem } from 'composables/shared/LinkBlock/LinkBlockItem.model';
import { ComponentProps } from 'lib/component-props';

type LinkBlockFields = {
  items: LinkBlockItem[];
  headline: Field<string>;
  backgroundColor: Field<string>;
};

export type LinkBlockProps = ComponentProps & {
  fields: LinkBlockFields;
};

export const LinkBlock: FC<LinkBlockProps> = ({ rendering }) => {
  const {
    items: links,
    headline,
    backgroundColor,
  } = mapSharedPropertiesToFields<LinkBlockFields>(rendering.fields as SitecoreFieldTypes);
  return <LinkBlockComponent links={links} headline={headline} backgroundColor={backgroundColor} />;
};

export default withDatasourceCheck()<LinkBlockProps>(LinkBlock);
